import DOMPurify from 'dompurify';

const scriptTagRegex = /<script[\s\S]*?>[\s\S]*?<\/script>/gi;

export const getSanitisedDocIfContainsScript = (src: string) => {
  const matches = src.match(scriptTagRegex);
  if (matches && matches.length) {
    const sanitizedHtml = DOMPurify.sanitize(src, { ADD_TAGS: ['script'] });
    return sanitizedHtml;
  }
  return null;
};
